import React from 'react'

import { Text, Main } from '../../../components'
import { FormattedMessage } from 'react-intl'

export function Unjoinable() {
  return (
    <Main.Container>
      <Main.Title>
        <FormattedMessage
          id="boarding.organization.join.unjoinable.title"
          defaultMessage="You cannot join this organization by yourself."
          values={{}}
        />
      </Main.Title>
      <Text.Corpus style={{ lineHeight: '1.8em' }}>
        <FormattedMessage
          id="boarding.organization.join.unjoinable.description"
          defaultMessage="If you think this is an issue, please reach out to the organization
        admin, or our support if the problem persists."
          values={{}}
        />
      </Text.Corpus>
    </Main.Container>
  )
}
